export default __webpack_public_path__ + "static/media/8.df1bcb6c.pdf";